import Link from 'next/link';
import { PageHeaderMenuItem, RenderSecondLevelMenuItemProps } from '@/components/PageHeader/PageHeader.model';
import styles from '@/components/PageHeader/styles/mobileNavBar.module.scss';
import { renderThirdLevelMenuItem } from '@/components/PageHeader/renderThirdLevelMenuItem';

/**
 * Renders a second-level menu item with optional submenus.
 * @param props - The properties for rendering the second-level menu item.
 * @returns A JSX element representing the second-level menu item.
 */
export function renderSecondLevelMenuItem(props: RenderSecondLevelMenuItemProps): JSX.Element {
  const {
    secondLevelMenuItem,
    secondLevelItemIndex,
    allProductVersionsInfo,
    countryCode,
    isElavon,
    renderFourthLevelMenuItemWrapper,
  } = props;

  // Ensure renderThirdLevelMenuItem always returns a JSX.Element
  function mapThirdLevelMenuItems(
    thirdLevelMenuItem: PageHeaderMenuItem,
    thirdLevelItemIndex: number,
    allProductVersionsInfo: any,
    countryCode: string,
    isElavon: boolean,
    renderFourthLevelMenuItemWrapper: (value: PageHeaderMenuItem, index: number) => JSX.Element | undefined
  ): JSX.Element {
    return (
      renderThirdLevelMenuItem(
        thirdLevelMenuItem,
        thirdLevelItemIndex,
        allProductVersionsInfo,
        countryCode,
        isElavon,
        renderFourthLevelMenuItemWrapper
      ) || <></> // Fallback to an empty fragment if undefined
    );
  }

  return (
    <li key={secondLevelMenuItem.id}>
      <Link href={`${secondLevelMenuItem.url}` || '#'}>
        <a
          className={styles.nested}
          href={`${secondLevelMenuItem.url}` || '#'}
          data-testid={`secondLevel-${secondLevelMenuItem.id}`}
          id={`secondLevel-${secondLevelMenuItem.id}`}
        >
          {secondLevelMenuItem.value}
        </a>
      </Link>
      {secondLevelMenuItem?.hasSubMenus && (
        <ul className={`${styles.subMenu} ${styles.level3} level3`}>
          {secondLevelMenuItem?.menuItems?.items?.map((thirdLevelMenuItem, thirdLevelItemIndex) =>
            mapThirdLevelMenuItems(
              thirdLevelMenuItem,
              thirdLevelItemIndex,
              allProductVersionsInfo,
              countryCode,
              isElavon,
              renderFourthLevelMenuItemWrapper
            )
          )}
        </ul>
      )}
    </li>
  );
}